import React from 'react';
import { Text, StyleSheet } from 'react-native';
import PlusIcon from '../../../../../../../16pxIcons/PlusIcon';
import Style from '../../../../../../../../constants/Style';
import PressableStyled from '../../../../../../../PressableStyled';
import Colors from '../../../../../../../../constants/Colors';

interface AssignUserGroupButtonProps {
  onPress: () => void,
  disabled?: boolean,
  invalid: boolean,
}

const AssignUserGroupButton = ({
  onPress, disabled, invalid,
}: AssignUserGroupButtonProps) => <PressableStyled
  {...{ onPress, disabled }}
  style={[styles.addTagButton, disabled && styles.disabled, invalid && styles.invalid]}
  testID='am-issue-add-user-group-btn'
  maintainOpacityWhenDisabled
>
    <PlusIcon
      color={styles.text.color}
      style={styles.plusIcon}
    />
    <Text style={styles.text}>{'Assign user group'}</Text>
  </PressableStyled>;

const styles = StyleSheet.create({
  addTagButton: {
    ...Style.row,
    height: 32,
    paddingHorizontal: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.light.hereworksDarkBlue,
    backgroundColor: '#FFF',
    marginVertical: 2,
    zIndex: 1,
  },
  disabled: {
    opacity: 0.2,
  },
  invalid: {
    borderColor: Colors.light.hereworksRed500,
  },
  plusIcon: {
    marginEnd: 8,
  },
  text: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
});

export default AssignUserGroupButton;
